/**
 * <ffp-pricing-modal>
 * Global rose pricing modal + floating CTA. Opens from any [data-ffp-open-pricing] trigger.
 */

class FfpPricingModal extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-ffp-pricing-dialog]');
    this.fab = this.querySelector('[data-ffp-pricing-fab]');

    this.dialog?.querySelector('[data-ffp-pricing-close]')?.addEventListener('click', () => this.close());
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.dialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.dialog?.open) this.close();
    });

    this.fab?.addEventListener('click', () => this.open());

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-ffp-open-pricing]');
      if (!trigger || trigger === this.fab || trigger.hasAttribute('disabled')) return;
      event.preventDefault();
      this.open();
    });
  }

  open() {
    if (!this.dialog) return;
    if (!this.dialog.open) this.dialog.showModal();
    this.dialog.querySelector('[data-ffp-pricing-close]')?.focus();
  }

  close() {
    if (!this.dialog?.open) return;
    this.dialog.close();
  }
}

/** Sync pricing chips + bulk badge inside bouquet builder. */
export function syncBuilderPricingUi(builder) {
  const tier =
    builder.roseColourField?.selectedOptions?.[0]?.dataset.tier === 'premium' ? 'premium' : 'red';
  const roseCount = builder.getRoseCount?.() ?? 0;
  const threshold = builder.volumeThreshold ?? 250;

  builder.querySelectorAll('[data-ffp-pricing-chip]').forEach((chip) => {
    chip.classList.toggle('is-active', chip.dataset.ffpPricingChip === tier);
  });

  builder.querySelectorAll('[data-ffp-bulk-badge]').forEach((badge) => {
    badge.hidden = roseCount <= threshold;
  });
}

if (!customElements.get('ffp-pricing-modal')) {
  customElements.define('ffp-pricing-modal', FfpPricingModal);
}
